<template>
  <v-dialog :value="true" max-width="500">
    <v-card class="pa-4" flat>
      <v-form @submit.prevent="updateMember" v-model="isFormValid" ref="form">
        <v-card-title>Edit member</v-card-title>
        <v-card-text
          ><div class="mb-1 subtitle-2 grey3--text">Contact name</div>
          <v-text-field
            v-model="name"
            :rules="nameRules"
            placeholder="Name"
            outlined
            dense
          ></v-text-field>
          <div class="mb-1 subtitle-2 grey3--text">Phone number</div>
          <v-text-field
            v-model="phone"
            :rules="phoneNumberRules"
            placeholder="Phone"
            outlined
            dense
          ></v-text-field>
          <v-btn
            class="mt-2 primary white--text lowercase-text"
            block
            plain
            :loading="$store.state.loading.updateMemberBtn.load"
            :disabled="$store.state.loading.updateMemberBtn.disabled"
            type="submit"
          >
            Update member
          </v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="$emit('close')">CLOSE</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["member", "group"],
  data() {
    return {
      name: "",
      phone: "",
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length >= 3) || "Name must be at least 3 characters",
      ],
      phoneNumberRules: [
        (v) => !!v || "Phone number is required",
        (v) => /^[0-9]{10}$/.test(v) || "Phone number must be 10 digits",
      ],
      isFormValid: false,
    };
  },

  methods: {
    async updateMember() {
      if (this.$refs.form.validate()) {
        // Form is valid, perform form submission or other actions
        await this.$store.dispatch("members/updateMember", {
          id: this.member._id,
          groupId: this.group._id,
          values: {
            name: this.name,
            phone: this.phone,
          },
        });
        this.closeDialog();
      }
    },
    closeDialog() {
      this.$emit("close");
    },
  },
  mounted() {
    this.name = this.member.name;
    this.phone = this.member.phone;
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none;
}
.row-pointer {
  cursor: pointer;
  color: #2c5282;
}
.custom-card {
  /* Add your additional border radius values */
  border-radius: 10px;
}
</style>
